import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { eswiEnvs, eswiUtils } from "@/tra/tancis/eswi/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_SRCH_HS_APP,
    SG_SRCH_HS_CODE_LIST,
} from "@/tra/tancis/eswi/hs/vrfn/service/EswiHsVrfnService";

export const ESWI0101001Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const pgeUid = "UI-ESWO-0107-039Q"; // Page Unique identifier !== 화면 고유 식별자 ==! 	HS코드 심사 목록	HS코드 심사 목록을 조회한다.
    //const pgeTitle = "Registration Approval List"; // Page Title !== 페이지 타이틀 ==!
    const { pgeUid, menuId } = usePage({
        auth: ["auth_eswi0007", "auth_eswi0008"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const [orgCdList, setOrgCdList] = useState();

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "hsCd" },
            { area: "comnCd", comnCd: "ESW0031" },
            { area: "comnCd", comnCd: "ESW0032" },
            { area: "comnCd", comnCd: "ESW0030" },
            { area: "comnCd", comnCd: "ESW0029" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        srchHsVrfnForm: useForm({
            defaultSchema: SF_SCHEMA_SRCH_HS_APP,
            defaultValues: {
                srchSbmtStrtDtm: comnUtils.getDate({ m: -1 }),
                srchSbmtEndDtm: comnUtils.getDate(),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Registering HS Code List !== Item Tab HS Code 등록 ==!
        srchHsVrfnList: useGrid({
            defaultSchema: SG_SRCH_HS_CODE_LIST,
            page: 0,
            size: 10,
        }),
    };

    const render = {
        srchHsVrfnList: {
            cell: {
                hsAppNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Layout direction="col" gap={1}>
                            <Link to={`${URLS.eswi0101002s}/${rowValues.hsAppUuid}`}>{`${rowValues.hsAppNo}`}</Link>
                        </Layout>
                    );
                },
                btnRcve: (props: any) => {
                    const { binding, rowValues, value } = props;
                    console.log("rowValues ", rowValues.asnmtCfrmDtm);
                    let bVisible = rowValues.asnmtCfrmDtm == null;
                    let usrVisible = rowValues.asinOfcrId == auth.get("usrId");

                    if(bVisible && usrVisible) {
                        return (
                            <Button
                                type="button"
                                color="success"
                                onClick={() => {
                                    handler.updateReceived(rowValues.hsAppUuid);
                                }}
                            >
                                {t("L_RCVE_1")}
                            </Button>
                        );
                    }
                },
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsVrfnList: useFetch({
            api: async (page = grid.srchHsVrfnList.page) => {
                return APIS.getHsVrfnList(form.srchHsVrfnForm.getValues(), page, grid.srchHsVrfnList.size);
            },
            enabled: comnUtils.isEmpty(form.srchHsVrfnForm.errors) && form.srchHsVrfnForm.isSubmitted,
            key: [grid.srchHsVrfnList.page, grid.srchHsVrfnList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.srchHsVrfnForm.getValues(),
                    page: grid.srchHsVrfnList.page,
                    size: grid.srchHsVrfnList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
        updateReceived: useFetch({
            api: (hsAppUuid) => {
                return APIS.updateReceived(hsAppUuid);
            },
            onSuccess: (data) => {
                console.log("data ", data);
                navigate(URLS.eswi0101002s + "/" + data.info.content.hsAppUuid);
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
        getOrgCdList: useFetch({
            api: () => {
                return eswiUtils.getOrgCdList();
            },
            onSuccess: (data) => {
                const orgCdList = data || [];
                orgCdList.map((item: any) => {
                    if (item.orgAbrtNm) {
                        item.label = "[" + item.orgAbrtNm + "] " + item.label;
                    }
                });

                setOrgCdList(orgCdList);
            },
            onError: () => {},
            showToast: false,
        }),
    };
    const handler = {
        getHsVrfnList: () => {
            form.srchHsVrfnForm.handleSubmit(
                (data) => {
                    grid.srchHsVrfnList.setPage(0);
                    fetch.getHsVrfnList.fetch(0);
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        updateReceived: (hsAppUuid: any) => {
            fetch.updateReceived.fetch(hsAppUuid);
        },
        setInit: async () => {
            // ======== 임시 로직 ============ tin으로 기관 정보 조회해서 form에 orgCd, orgNm 값 세팅
            //const info = await eswiUtils.setOrgInfoByTin(auth.get("tin"));
            //form.srchHsVrfnForm.setValues(info);

            // fetch.getOrgCdList.fetch();
            // 목록 조회
            handler.getHsVrfnList();
        },
    };

    useEffect(() => {
        // 이전 검색 조건 세팅
        eswiUtils.setSrchFormFromStore(form.srchHsVrfnForm, pgeStore);
        // 초기화
        handler.setInit();
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("L_APP_INFO")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.srchHsVrfnForm.schema.srchOrgCd} options={orgCdList} />
                            <Group.Control {...form.srchHsVrfnForm.schema.srchOrgChpnNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.srchHsVrfnForm.schema.srchHsAppNo} />
                            <Group.Control {...form.srchHsVrfnForm.schema.srchPrcssStatCd} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.srchHsVrfnForm.schema.srchSbmtDtm}
                                edit={true}
                                rangeButton={2}
                                controlSize={10}
                            />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.srchHsVrfnForm.schema.srchAprvDtm}
                                edit={true}
                                rangeButton={2}
                                controlSize={10}
                            />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button role="reset" />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getHsVrfnList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.srchHsVrfnList.grid}
                            data={fetch.getHsVrfnList.data?.list}
                            render={render.srchHsVrfnList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
